<template>
  <div class="main-content">
    <div style="margin-bottom: 10px;text-align: left;">
      <el-button no="onAdd" type="primary" @click="onAdd">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
      <el-button no="onDel" type="danger" :disabled="selectLength === 0" @click="onDel">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
    </div>
    <div class="section grid-wrapper">
      <cargo-ag-grid
        :config-module="configModule"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div slot="footer" style="text-align: right">
      <el-button no="37" type="primary" @click="onConfirm">{{ $t('common.btn.confirm') }}</el-button>
      <el-button no="38" @click="onCancel">{{ $t('common.btn.cancel') }}</el-button>
    </div>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { querySurchargeFclConfig, saveSurchargeFCLConfig } from '@/api/price/surchargeFcl'
import { chargeItemCompatibleLanguage } from '@/utils/commonUtil'
import { ChargeItem } from '@/class/model/mdm/chargeItem'

export default {
  name: 'ConfigureTheSurcharge',
  components: { CargoAdvanceSelect },
  props: {
    configModule: { type: String, default: '22320104' },
    gridOptions: { type: Object, default: () => {} },
    selectLength: { type: Number, default: 0 }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      rowData: [],
      chargeTypes: [],
      priceTypes: PriceConstant.PRICE_ALL_TYPES,
      delUuid: [],
      chargeItemSet: new Set()
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: ' ', maxWidth: 40, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
          field: 'serialNo',
          width: 150,
          cellRenderer: function(params) {
            return parseInt(params.node.id) + 1
          }
        },
        { headerName: this.$t('Pricing.PriceType'), field: 'freightType', colId: 'freightType', width: 200, flex: 1,
          editable: true,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            selectProps: {
              filterable: true
            },
            options: PriceConstant.PRICE_ALL_TYPES,
            tagName: 'chineseName',
            tagValue: 'code'
          },
          valueFormatter: params => {
            return CommonState.getNameByCode(PriceConstant.PRICE_ALL_TYPES, params.value)
          },
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          }
        },
        {
          headerName: this.$t('Pricing.FeeName'), field: 'chargeScaleCode', colId: 'chargeScaleCode', width: 200, flex: 1,
          editable: true,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              staticOptions: [...this.chargeItemSet],
              tagValue: 'itemId',
              tagName: this.$store.getters.language === 'zh' ? 'zhName' : 'enName',
              filterable: true,
              filterTagNames: ['chargecode', 'enName', 'zhName', 'cnShortName', 'scaleCode', 'languageName'],
              filterType: 'global',
              methodParams: { active: true }
            }
          },
          cellRenderer: (params) => {
            if (!params.value) {
              return ''
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          },
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          }
        },
        {
          headerName: this.$t('Pricing.ChargeType'), field: 'chargeType', colId: 'chargeType', width: 200, flex: 1,
          editable: true,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: {
            selectProps: {
              filterable: true
            },
            options: this.chargeTypes,
            tagName: 'label',
            tagValue: 'value'
          },
          cellRenderer: (params) => {
            return PriceUtils.chargeTypeLabelFunc(params)
          },
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          }
        },
        {
          headerName: this.$t('Pricing.ChargeUnit'), field: 'unit', colId: 'unit', width: 200, flex: 1,
          editable: true,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_ChargeUnit,
              tagValue: 'code',
              tagName: 'chineseName',
              methodParams: { unit: true, seaFreight: true },
              filterable: true,
              clearable: false
            }
          },
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
          },
          onCellValueChanged: (params) => {
            this.onCellChange(params)
          }
        }
      ]
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      const source = []
      source.push({ 'label': this.$t('Pricing.Surcharge'), 'value': 'S' })
      source.push({ 'label': this.$t('Pricing.LocalCharge'), 'value': 'L' })
      source.push({ 'label': this.$t('Pricing.DesCharge'), 'value': 'D' })
      this.chargeTypes = source
      querySurchargeFclConfig().then(res => {
        this.rowData = res.data
      })
      this.initChargeItemSet()
    },
    initChargeItemSet() {
      const results = chargeItemCompatibleLanguage()
      this.chargeItemSet = new Set(results)
    },
    onConfirm() {
      if (this.rowData && this.rowData.length > 0) {
        const map = {}
        for (const item of this.rowData) {
          if (item.chargeScaleCode) {
            const chargeItems = ChargeItem.getChargeItemById(item.chargeScaleCode)
            item.chargeScaleCode = chargeItems ? chargeItems.scaleCode : ''
          }
          // 必填校验
          if (!item.chargeScaleCode) {
            this.$message.warning(this.$t('CargoMsg.Cargo_ExpenseDescriptionCanTBeEmpty'))
            // 费用名称必填
            return
          }
          if (!item.chargeType) {
            this.$message.warning(this.$t('CargoMsg.Cargo_ChargeType') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
            // 费用类型必填
            return
          }
          const key = item.freightType + item.chargeScaleCode + item.chargeType + item.unit
          if (map.hasOwnProperty(key)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_ThereIsDuplicateData'))
            // 存在重复数据
            return
          }
          map[key] = true
        }
      }
      const data = {
        surchargeFclConfigs: this.rowData,
        delSurchargeFclConfigKeys: this.delUuid
      }
      // 数据重复校验
      saveSurchargeFCLConfig(data).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
        this.$emit('confirm')
      })
    },
    onCancel() {
      this.$emit('cancel')
    },
    onAdd() {
      const data = {
        freightType: null,
        chargeScaleCode: null,
        chargeType: '',
        unit: ''
      }
      this.rowData.push(data)
    },
    onDel() {
      const rows = this.gridOptions.api.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      const delUuid = this.delUuid
      for (let i = this.rowData.length - 1; i >= 0; --i) {
        const row = this.rowData[i]
        if (rows.includes(row)) {
          if (row.uuid) {
            delUuid.push(row.uuid)
          }
          this.rowData.splice(i, 1)
        }
      }
      const tempRowData = this.rowData
      this.rowData = []
      this.$nextTick(() => {
        this.rowData = tempRowData
      })
    },
    onCellChange(params) {
      const { node } = params
      if (node.data.uuid) {
        node.data.dirty = true
      }
    }
  }
}
</script>

<style scoped>

</style>
